import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import Select from '../../controls/Select'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import { MdErrorOutline } from 'react-icons/md'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { useToast } from '../../controls/Toast/ToastService';

const schema = yup.object().shape({
    bloodPressure: yup.string().required("Blood Pressure is required"),
    patientBond: yup.string().required("Bond is required"),
    patientType: yup.string().required("Type is required"),
    weight: yup.string().required("Weight is required"),
    patientName: yup.string().required("Patient Name is required"),
    patientAddress: yup.string().required("Address is required"),
    mobile: yup.string().required("Mobile is required"),
})

export default function EditConfirmed({ isOpen, setIsOpen, id, item, refresh }) {
    const { start, end } = useGlobalLoader()
    const [loding, setLoding] = useState(false)
    const toast = useToast()
    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            id: 0,
            bloodPressure: "N/A",
            patientBond: "Cash",
            patientType: "Normal",
            weight: 0,
            patientName: "",
            patientAddress: "",
            mobile: "",
        },
        enableReinitialize: true,
        validationSchema: schema,
        onSubmit(val) {
            handleEdit(val)
        }
    })
    const handleEdit = (val) => {
        setLoding(true)
        start()
        opdRegisteredCrud.Edit(val).then(res => {
            let mdata = res.data
            if (mdata.succeeded) {
                setIsOpen(false)
                refresh()
                toast.open('Updated Successfully', <IoCheckmarkCircleOutline />, "success")
            } else {
                toast.open(mdata.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    useEffect(() => {
        if (item)
            setValues({
                id: item.id,
                patientAddress: item.patientAddress,
                bloodPressure: item.bloodPressure,
                patientBond: item.patientBond,
                patientType: item.patientType,
                weight: item.weight,
                patientName: item.patientName,
                mobile: item.mobile,
            })
    }, [item])

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"ConfirmOnline"}>
            <form onSubmit={handleSubmit}>
                <div className="p-6 space-y-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div>
                            <label htmlFor="patientName" className="block mb-2 text-sm font-medium text-gray-900">Name</label>
                            <Input placeholder="Name"
                                type="text"
                                id="patientName"
                                Icon={"@"}
                                value={values.patientName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientName && touched.patientName}
                            />
                            {errors.patientName && touched.patientName && <p className='text-red-600 text-xs'>{errors.patientName}</p>}
                        </div>
                        <div>
                            <label htmlFor="mobile" className="block mb-2 text-sm font-medium text-gray-900">Mobile</label>
                            <Input placeholder="Mobile"
                                type="text"
                                id="mobile"
                                Icon={"@"}
                                value={values.mobile}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.mobile && touched.mobile}
                            />
                            {errors.mobile && touched.mobile && <p className='text-red-600 text-xs'>{errors.mobile}</p>}
                        </div>
                        <div>
                            <label htmlFor="weight" className="block mb-2 text-sm font-medium text-gray-900">Weight</label>
                            <Input placeholder="Weight"
                                type="number"
                                id="weight"
                                Icon={"@"}
                                value={values.weight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.weight && touched.weight}
                            />
                            {errors.weight && touched.weight && <p className='text-red-600 text-xs'>{errors.weight}</p>}
                        </div>
                        <div>
                            <label htmlFor="bloodPressure" className="block mb-2 text-sm font-medium text-gray-900">Blood Pressure</label>
                            <Input placeholder="BloodPressure"
                                id="bloodPressure"
                                type="text"
                                Icon={"@"}
                                value={values.bloodPressure}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.bloodPressure && touched.bloodPressure}
                            />
                            {errors.bloodPressure && touched.bloodPressure && <p className='text-red-600 text-xs'>{errors.bloodPressure}</p>}
                        </div>
                        <div>
                            <label htmlFor="patientType" className="block mb-2 text-sm font-medium text-gray-900">
                                Patient Type
                            </label>
                            <Select
                                Icon={'@'}
                                id="patientType"
                                name="patientType"
                                value={values.patientType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientType && touched.patientType}
                            >
                                <option value="Normal">Normal</option>
                                <option value="New">New</option>
                                <option value="Under NF">Under NF</option>
                            </Select>
                            {errors.patientType && touched.patientType && (
                                <p className="text-red-600 text-xs">{errors.patientType}</p>
                            )}
                        </div>
                        <div>
                            <label htmlFor="patientBond" className="block mb-2 text-sm font-medium text-gray-900">
                                Bond
                            </label>
                            <Select
                                Icon={'@'}
                                id="patientBond"
                                name="patientBond"
                                value={values.patientBond}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientBond && touched.patientBond}
                            >
                                <option value="Cash">Cash</option>
                                <option value="UPI">UPI</option>
                            </Select>
                            {errors.patientBond && touched.patientBond && (
                                <p className="text-red-600 text-xs">{errors.patientBond}</p>
                            )}
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="patientAddress" className="block mb-2 text-sm font-medium text-gray-900">Address</label>
                            <Input placeholder="Address"
                                type="text"
                                id="patientAddress"
                                Icon={"@"}
                                value={values.patientAddress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientAddress && touched.patientAddress}
                            />
                            {errors.patientAddress && touched.patientAddress && <p className='text-red-600 text-xs'>{errors.patientAddress}</p>}
                        </div>
                    </div>
                </div>
                <div className="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                    {!loding ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>
        </Modal>
    )
}